import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./DashboardMobile.module.css";
import CreateProductForm from "../CrearProducto/CrearProducto";
import ProductList from "../ProductList/ProductList";
import CreateSoupKits from "../CreateSoupKits/CreateSoupKits";
import KitList from "../KitList/KitList";
import TraePedidos from "../TraePedidos/TraePedidos";

const DashboardMobile = () => {
  const [showCreateProductForm, setShowCreateProductForm] = useState(false);
  const [showProductList, setShowProductList] = useState(false);
  const [showCreateSoupKits, setShowCreateSoupKits] = useState(false);
  const [showKitList, setShowKitList] = useState(false);
  const [showPedidos, setShowPedidos] = useState(false);
  const [showShippingInfo, setShowShippingInfo] = useState(false);

  // State for shipping data
  const [shippingData, setShippingData] = useState(null);
  const [envio, setEnvio] = useState(false);
  const [precio, setPrecio] = useState(0);
  const [envioGratis, setEnvioGratis] = useState(0);

  // Fetch shipping data on mount
  useEffect(() => {
    const fetchShippingData = async () => {
      try {
        const response = await axios.get(
          "https://rezuma-back.onrender.com/ship/shipping"
        );
        setShippingData(response.data[0]); // Assuming the API returns an array with one object
        setEnvio(response.data[0].envio);
        setPrecio(response.data[0].precio);
        setEnvioGratis(response.data[0].envioGratis);
      } catch (error) {
        console.error("Error fetching shipping data:", error);
      }
    };
    fetchShippingData();
  }, []);

  // Function to update shipping data
  const updateShipping = async () => {
    try {
      const response = await axios.put(
        `https://rezuma-back.onrender.com/ship/shipping/${shippingData.id}`,
        {
          envio,
          precio,
          envioGratis,
        }
      );
      setShippingData(response.data); // Update state with new data
      alert("Datos de envío actualizados correctamente");
    } catch (error) {
      console.error("Error al actualizar el envío:", error);
      alert("Error al actualizar");
    }
  };

  const toggleCreateProductForm = () => {
    setShowCreateProductForm(!showCreateProductForm);
    hideAllExcept("showCreateProductForm");
  };

  const toggleProductList = () => {
    setShowProductList(!showProductList);
    hideAllExcept("showProductList");
  };

  const toggleCreateSoupKits = () => {
    setShowCreateSoupKits(!showCreateSoupKits);
    hideAllExcept("showCreateSoupKits");
  };

  const toggleKitList = () => {
    setShowKitList(!showKitList);
    hideAllExcept("showKitList");
  };

  const togglePedidos = () => {
    setShowPedidos(!showPedidos);
    hideAllExcept("showPedidos");
  };

  const toggleShippingInfo = () => {
    setShowShippingInfo(!showShippingInfo);
    hideAllExcept("showShippingInfo");
  };

  const hideAllExcept = (stateKey) => {
    if (stateKey !== "showCreateProductForm") setShowCreateProductForm(false);
    if (stateKey !== "showProductList") setShowProductList(false);
    if (stateKey !== "showCreateSoupKits") setShowCreateSoupKits(false);
    if (stateKey !== "showKitList") setShowKitList(false);
    if (stateKey !== "showPedidos") setShowPedidos(false);
    if (stateKey !== "showShippingInfo") setShowShippingInfo(false);
  };

  return (
    <div className={styles.background}>
      <div className={styles.dashboard}>
        <h1 className={styles.title}>Dashboard</h1>
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={toggleCreateProductForm}>
            Crear Producto
          </button>
          <button className={styles.button} onClick={toggleProductList}>
            {showProductList ? "Ocultar Productos" : "Traer Productos"}
          </button>
          <button className={styles.button} onClick={toggleCreateSoupKits}>
            Crear Kit de Sopas
          </button>
          <button className={styles.button} onClick={toggleKitList}>
            {showKitList ? "Ocultar Kits" : "Mostrar Kits"}
          </button>
          <button className={styles.button} onClick={togglePedidos}>
            {showPedidos ? "Ocultar Pedidos" : "Traer Pedidos"}
          </button>
          <button className={styles.button} onClick={toggleShippingInfo}>
            {showShippingInfo ? "Ocultar Envío" : "Mostrar Envío"}
          </button>
        </div>

        {/* Shipping Information Form */}
        {shippingData && showShippingInfo && (
          <div className={styles.shippingInfo}>
            <h4>Información de Envío</h4>
            <form
              className={styles.shippingForm}
              onSubmit={(e) => {
                e.preventDefault();
                updateShipping();
              }}
            >
              <label>
                Cobrar Envío:
                <input
                  type="checkbox"
                  checked={envio}
                  onChange={(e) => setEnvio(e.target.checked)}
                />
              </label>
              <label>
                Precio:
                <input
                  type="number"
                  value={precio}
                  onChange={(e) => setPrecio(e.target.value)}
                />
              </label>
              <label>
                Cantidad de Kits para envío gratis:
                <input
                  type="number"
                  value={envioGratis}
                  onChange={(e) => setEnvioGratis(e.target.value)}
                />
              </label>
              <button type="submit" className={styles.button}>
                Actualizar Envío
              </button>
            </form>
          </div>
        )}

        {showCreateProductForm && <CreateProductForm />}
        {showProductList && <ProductList />}
        {showCreateSoupKits && <CreateSoupKits />}
        {showKitList && <KitList />}
        {showPedidos && <TraePedidos />}
      </div>
    </div>
  );
};

export default DashboardMobile;
